import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { FormattedMessage } from 'react-intl';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";
import Tooltip from '@material-ui/core/Tooltip';

// @material-ui/icons 
import MenuIcon from "@material-ui/icons/Menu";
import ViewList from "@material-ui/icons/ViewList";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// custom components
import headerStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";
import Button from "components/react-template/CustomButtons/Button.jsx";
import HeaderLinks from "./HeaderLinks";

// util
import { getTopMenu } from 'util/common';

/**
 * material-dashboard-pro-react-v1.5.0 > AdminNavbar.jsx(기존 Header.jsx) 참고
 * v1.5.0에서 AdminNavbar.jsx로 변경됨 
 */
function Header({ ...props }) {
    const topMenu = getTopMenu(props);

    // 메뉴 타이틀 문구 생성
    function makeMenuTitle() {
        return <FormattedMessage id={`topmenu.${topMenu}`} />;
    }

    const { classes, color } = props;
    const { isSidebarOpen, onToggleSidebar, onToggleMobileSidebar } = props;

    return (
        <AppBar className={classes.appBar + cx({ [" " + classes[color]]: color })}>
            <Toolbar className={classes.container}>
                {/* 화면이 클 때만 보이는 Sidebar Open/Close 버튼 (xs/sm사이즈에서 hidden, md/lg/xl사이즈에서만 보임) */}
                <Hidden smDown implementation="css">
                    <div className={classes.sidebarMinimize}>
                        <Tooltip
                            title={<FormattedMessage id={`common.sidebar.${isSidebarOpen ? "minimize" : "maximize" }`} />}
                            placement="bottom-start"
                        >
                            <span>
                                <Button
                                    justIcon
                                    round
                                    color="white"
                                    onClick={onToggleSidebar}
                                >
                                { isSidebarOpen ? <ArrowBackIcon className={classes.sidebarMiniIcon} />
                                                    : <ViewList className={classes.sidebarMiniIcon} /> }
                                </Button>
                            </span>
                        </Tooltip>
                    </div>
                </Hidden>

                {/* 타이틀 (화면사이즈에 상관없음) */}
                <div className={classes.flex}>
                    <h4>{makeMenuTitle()}</h4>
                </div>

                    {/* 화면이 클 때 보이는 메뉴 (xs/sm사이즈에서 hidden, md/lg/xl사이즈에서만 보임) */}
                    <Hidden smDown implementation="css">
                        <HeaderLinks topMenu={topMenu} source="header"/>
                    </Hidden>

                    {/* 화면이 작을 때만 보이는 Sidebar Open 아이콘 (xs/sm사이즈에서만 보임, md/lg/xl사이즈에서 안보임) */}
                    <Hidden mdUp implementation="css">
                        <Tooltip
                            title={<FormattedMessage id="common.sidebar.open" />}
                            placement="bottom-start"
                        >
                            <span>
                                <Button
                                    className={classes.appResponsive}
                                    color="transparent"
                                    justIcon
                                    aria-label="open drawer"
                                    onClick={onToggleMobileSidebar}
                                >
                                    <MenuIcon />
                                </Button>
                            </span>
                        </Tooltip>
                    </Hidden>
                </Toolbar>
            </AppBar>
        );

}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),

    isSidebarOpen: PropTypes.bool.isRequired,
    onToggleSidebar: PropTypes.func.isRequired,
    onToggleMobileSidebar: PropTypes.func.isRequired
};

export default withStyles(headerStyle)(Header);
